import type { TreeNode } from '../../../../../../types'

export const getTopLevelElements = (nodes: TreeNode[], result: TreeNode[] = []): TreeNode[] => {
  for (const node of nodes) {
    if (
      node.type === 'element' ||
      node.type === 'mdxJsxTextElement' ||
      node.type === 'mdxJsxFlowElement' ||
      node.type === 'paragraph' ||
      node.type === 'heading' ||
      node.type === 'blockquote' ||
      node.type === 'list' ||
      node.type === 'code' ||
      node.type === 'thematicBreak' // hr
    ) {
      result.push(node)
      continue
    }

    if (node.children) {
      getTopLevelElements(node.children, result)
    }
  }
  return result
}

export const filterTopLevelASTElements = (elements: TreeNode[]): TreeNode[] => {
  const filtered: TreeNode[] = []

  for (const element of elements) {
    const isNested = elements.some(otherElement => {
      if (otherElement === element) return false
      return (
        element.position.start.line >= otherElement.position.start.line &&
        element.position.end.line <= otherElement.position.end.line
      )
    })

    if (!isNested) {
      filtered.push(element)
    }
  }
  return filtered.sort((a, b) => a.position.start.line - b.position.start.line)
}
